import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ = ({ onOpenForm }) => {
  const faqs = [
    {
      question: 'Como funciona o pagamento em até 12x no boleto?',
      answer: 'Facilitamos o pagamento da sua viagem! Você pode parcelar em até 12 vezes no boleto, sem necessidade de cartão de crédito e sem análise de crédito. Basta solicitar um orçamento e nossa equipe te passa todas as condições.'
    },
    {
      question: 'O que está incluso no pacote para Porto Seguro?',
      answer: 'Nossos pacotes para Porto Seguro incluem: transporte ida e volta em ônibus executivo confortável, hospedagem na Pousada Verdes Mares, café da manhã diário, passeios ao Centro Histórico e Passarela da Cultura, e acompanhamento de guias especializados durante toda a viagem. O jantar pode ser contratado à parte.'
    },
    {
      question: 'Quantas pessoas normalmente viajam em grupo?',
      answer: 'Nossos grupos costumam ter entre 30 a 45 pessoas. Realizamos mais de 25 viagens por ano para Porto Seguro, sempre com grupos organizados e ambiente familiar. É uma ótima oportunidade para conhecer novas pessoas e fazer amizades!'
    },
    {
      question: 'A agência tem experiência com viagens para Porto Seguro?',
      answer: 'Sim! A A.R. Turismo tem mais de 10 anos de experiência levando famílias para Porto Seguro. Realizamos mais de 25 viagens por ano para este destino, com total conhecimento da região, melhores hospedagens e passeios imperdíveis.'
    },
    {
      question: 'Como é o ônibus executivo?',
      answer: 'Nosso ônibus executivo é super confortável, ideal para viagens longas. Possui poltronas reclináveis, ar-condicionado, iluminação adequada para viagens noturnas e amplo espaço interno. A viagem é acompanhada por guias especializados que garantem conforto e segurança.'
    },
    {
      question: 'Onde fica a Pousada Verdes Mares?',
      answer: 'A Pousada Verdes Mares está localizada a aproximadamente 300 metros da praia de Coroa Vermelha, em Porto Seguro. Oferece estrutura completa com piscina, área de lazer, jardim e café da manhã incluso. É perfeita para grupos e tem excelente custo-benefício.'
    },
    {
      question: 'Posso viajar sozinho(a) ou precisa ser em casal/família?',
      answer: 'Pode viajar sozinho(a) sim! Muitos de nossos clientes viajam sozinhos e fazem amizades durante a viagem. O ambiente é super acolhedor e familiar. Todos são bem-vindos!'
    },
    {
      question: 'Vocês fazem viagens aéreas também?',
      answer: 'Sim! Além das viagens rodoviárias para Porto Seguro, oferecemos pacotes aéreos para diversos destinos como Rio de Janeiro, Porto de Galinhas, Recife, João Pessoa e outros. Os pacotes aéreos incluem passagens, transfer e hospedagem.'
    },
    {
      question: 'Com quantos dias de antecedência devo reservar?',
      answer: 'Recomendamos reservar com pelo menos 30 dias de antecedência para garantir sua vaga e aproveitar as melhores condições de pagamento. Algumas datas especiais (férias de julho, feriados) costumam esgotar rapidamente.'
    },
    {
      question: 'Crianças pagam o mesmo valor que adultos?',
      answer: 'Não! Crianças geralmente têm valores diferenciados dependendo da idade e compartilhamento de quarto. Entre em contato pelo WhatsApp com as idades das crianças para receber um orçamento personalizado.'
    },
    {
      question: 'Posso escolher meu companheiro de quarto?',
      answer: 'Sim! Se estiver viajando em grupo de amigos ou família, você pode escolher com quem dividir o quarto. Para quem viaja sozinho, fazemos o possível para acomodar da melhor forma.'
    },
    {
      question: 'O que levar na mala para Porto Seguro?',
      answer: 'Recomendamos: roupas leves, trajes de banho, chinelos, protetor solar, boné/chapéu, óculos de sol, repelente e uma mochila pequena para os passeios. Para a viagem de ônibus, leve também um agasalho leve.'
    },
    {
      question: 'Existe seguro viagem?',
      answer: 'Sim, trabalhamos com seguro viagem que pode ser contratado à parte. Ele cobre despesas médicas, extravio de bagagem e outros imprevistos. Consulte nossa equipe para mais informações.'
    },
    {
      question: 'Como entro em contato para tirar mais dúvidas?',
      answer: 'Você pode entrar em contato pelo WhatsApp (61) 99159-4985 ou preencher o formulário aqui no site. Nossa equipe responde rapidamente e tira todas as suas dúvidas!'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full mb-4">
            <HelpCircle className="w-4 h-4" />
            <span className="font-semibold text-sm">Tire suas Dúvidas</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Perguntas <span className="text-red-600">Frequentes</span>
          </h2>
          <p className="text-lg text-gray-600">
            Encontre respostas para as dúvidas mais comuns
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white border border-gray-200 rounded-xl px-6 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-red-600 py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* CTA após FAQ */}
        <div className="mt-12 text-center bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Não encontrou sua resposta?
          </h3>
          <p className="text-gray-600 mb-6">
            Nossa equipe está pronta para te ajudar!
          </p>
          <button
            onClick={onOpenForm}
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-full text-lg transition-all duration-300 hover:scale-105 shadow-lg"
          >
            Solicitar Orçamento
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
